import objectFitImages from "object-fit-images";
import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";

export default {
  init() {
    // Cover
    objectFitImages();

    // Links target _blank
    Array.prototype.filter.call(
      document.querySelectorAll("a"),
      function (link) {
        if (link.hostname != window.location.hostname) link.target = "_blank";
      }
    );

    lightGallery(document.getElementById("lightgallery"), {
      plugins: [lgVideo],
      download: false,
      counter: false,
      autoplayFirstVideo: true,
      youtubePlayerParams: {
        modestbranding: 0,
        showinfo: 0,
        controls: 1,
        rel: 0,
        autoplay: 1,
      },
      speed: 500,
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js